"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AvailableAddToCartButton = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _AddToCartManager = _interopRequireDefault(require("./AddToCartManager"));
var _domainServices = require("@site/domain-services");
var _button = _interopRequireDefault(require("@ux/button"));
var _reactMintl = require("@godaddy/react-mintl");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("@site/utils");
const DEFAULT_TERM = '12';
const AvailableAddToCartButton = ({
  // State To Render The Button in (Remove or Add)
  productInCart = false,
  // Product Specific Data to be used in SAPI Post.
  domain = {},
  product = {},
  apiKey = 'dpp_search',
  trackingCode = '',
  plid = '1',
  market = '',
  basketId = '',
  additionalPackageAttributes = {},
  additionalPostDataAttributes = {},
  env = (0, _utils.getEnv)(window.location.href),
  resellerBaseOverride,
  // UX / UI Related.
  buttonClassNameOverride = '',
  addProps = {},
  removeProps = {},
  ContinueToCartComponent,
  // Event to use when Cart states change.
  onCartStateChange = () => {},
  addToCartText = '',
  verifyingText = '',
  removeFromCartText = '',
  removingFromCartText = ''
}) => {
  const {
    formatMessage
  } = (0, _reactMintl.useIntl)();
  const products = [{
    ...product,
    name: domain.Fqdn,
    term: `${(0, _utils.getDomainMonthlyTerms)({
      product: {
        domain,
        priceInfo: product.PriceInfo
      },
      defaultDomainTerms: DEFAULT_TERM
    })?.term}:Month`
  }];
  const sapiPostData = (0, _domainServices.constructSapiPost)({
    trackingCode,
    products,
    additionalPackageAttributes,
    additionalPostDataAttributes
  });
  const getClassNames = (defaults = '') => {
    return buttonClassNameOverride || defaults;
  };
  const AddToCart = ({
    onManagerActionOrStateChange
  }) => {
    const defaultAddClassNames = 'btn-filled btn-link ux-button-small spin-buy-button add-to-cart rounded';
    return /*#__PURE__*/_react.default.createElement(_button.default, (0, _extends2.default)({
      "data-cy": `${domain.DomainGUID}_add_to_cart_button`,
      "data-testid": `${domain.DomainGUID}_add_to_cart_button`,
      className: getClassNames(defaultAddClassNames),
      onClick: onManagerActionOrStateChange,
      design: "secondary",
      text: formatMessage({
        id: addToCartText || 'dppSolutionsBuyButtonTextAdd'
      })
    }, addProps));
  };
  AddToCart.propTypes = {
    onManagerActionOrStateChange: _propTypes.default.func
  };
  const VerifyingCart = () => {
    const textId = 'addingToCart';
    return /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: verifyingText || textId
    });
  };
  const RemoveFromCart = ({
    onManagerActionOrStateChange
  }) => {
    const defaultRemoveClassNames = 'btn-filled btn-link ux-button-small spin-buy-button add-to-cart cursor-inherit rounded';
    const RemoveFromCartButton = () => /*#__PURE__*/_react.default.createElement(_button.default, (0, _extends2.default)({
      className: getClassNames(defaultRemoveClassNames),
      "data-cy": `${domain.DomainGUID}_remove_from_cart_button`,
      onClick: onManagerActionOrStateChange,
      design: "secondary",
      text: formatMessage({
        id: removeFromCartText || 'remove'
      })
    }, removeProps));
    return ContinueToCartComponent ? /*#__PURE__*/_react.default.createElement(ContinueToCartComponent, {
      domain: domain
    }) : /*#__PURE__*/_react.default.createElement(RemoveFromCartButton, null);
  };
  RemoveFromCart.propTypes = {
    onManagerActionOrStateChange: _propTypes.default.func
  };
  const RemovingFromCart = () => {
    const textId = 'dppSolutionsRemoving';
    return /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: removingFromCartText || textId
    });
  };
  const FailedCtaComponent = () => {
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h6", {
      "data-cy": "unavailable_message"
    }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: "domainFailedAvailCheck"
    })));
  };
  return /*#__PURE__*/_react.default.createElement(_AddToCartManager.default, {
    onCartStateChange: onCartStateChange,
    ctaComplete: productInCart,
    sapiPostData: sapiPostData,
    trackingCode: trackingCode,
    plid: plid,
    basketId: basketId,
    apiKey: apiKey,
    market: market,
    env: env,
    resellerBaseOverride: resellerBaseOverride,
    customComponents: {
      CustomAddToCartComponent: AddToCart,
      CustomRemoveFromCartComponent: RemoveFromCart,
      CustomRunningComponent: VerifyingCart,
      CustomRevertingComponent: RemovingFromCart,
      CustomFailureComponent: FailedCtaComponent
    }
  });
};
exports.AvailableAddToCartButton = AvailableAddToCartButton;
AvailableAddToCartButton.propTypes = {
  domain: _propTypes.default.object.isRequired,
  product: _propTypes.default.shape({
    name: _propTypes.default.string,
    term: _propTypes.default.string,
    phase: _propTypes.default.string,
    redemptioncode: _propTypes.default.string
  }).isRequired,
  apiKey: _propTypes.default.string,
  trackingCode: _propTypes.default.string,
  productInCart: _propTypes.default.bool,
  plid: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  market: _propTypes.default.string,
  basketId: _propTypes.default.string,
  additionalPackageAttributes: _propTypes.default.object,
  additionalPostDataAttributes: _propTypes.default.object,
  buttonClassNameOverride: _propTypes.default.string,
  addProps: _propTypes.default.object,
  removeProps: _propTypes.default.object,
  onCartStateChange: _propTypes.default.func,
  ContinueToCartComponent: _propTypes.default.func,
  env: _propTypes.default.string,
  resellerBaseOverride: _propTypes.default.string,
  addToCartText: _propTypes.default.string,
  verifyingText: _propTypes.default.string,
  removeFromCartText: _propTypes.default.string,
  removingFromCartText: _propTypes.default.string
};